/**
 * Defines options for main use case.
 *
 * @since 5.3.0
 * @see https://developers.google.com/android/reference/com/google/mlkit/vision/facemesh/FaceMeshDetectorOptions.UseCase
 */
export var UseCase;
(function (UseCase) {
    /**
     * Return bounding box for detected face.
     *
     * @since 5.3.0
     * @see https://developers.google.com/android/reference/com/google/mlkit/vision/facemesh/FaceMeshDetectorOptions#public-static-final-int-bounding_box_only
     */
    UseCase[UseCase["BoundingBoxOnly"] = 0] = "BoundingBoxOnly";
    /**
     * Return face mesh info for detected face.
     * It detects at most 2 faces in this use case.
     *
     * @since 5.3.0
     * @see https://developers.google.com/android/reference/com/google/mlkit/vision/facemesh/FaceMeshDetectorOptions#public-static-final-int-face_mesh
     */
    UseCase[UseCase["FaceMesh"] = 1] = "FaceMesh";
})(UseCase || (UseCase = {}));
//# sourceMappingURL=definitions.js.map